/**
 * Хук для работы с настройками доставки
 * Дата: 26.01.2026 - TODO-036
 * Связан с: frontend/src/api/settings.ts, frontend/src/pages/Settings.tsx
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { settingsApi, UpdateDeliverySettingsRequest } from '@/api/settings';

export function useSettings(tenantId?: string) {
  const queryClient = useQueryClient();

  const settingsQuery = useQuery({
    queryKey: ['settings', 'delivery', tenantId],
    queryFn: () => settingsApi.getDeliverySettings(tenantId),
  });

  const updateMutation = useMutation({
    mutationFn: (data: UpdateDeliverySettingsRequest) =>
      settingsApi.updateDeliverySettings(data, tenantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'delivery'] });
    },
  });

  return {
    settings: settingsQuery.data,
    isLoading: settingsQuery.isLoading,
    isError: settingsQuery.isError,
    error: settingsQuery.error,
    updateSettings: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
